(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
 (function () {
  document.querySelectorAll('[data-yc-annbar]').forEach(function (bar) {
   var rot = bar.querySelector('[data-yc-annbar-rot]');
   var msgs = [];
   try { msgs = JSON.parse(bar.querySelector('[data-yc-annbar-msgs]').textContent); } catch (e) {}
   if (!rot || msgs.length < 2) return;
   var i = 0;
   setInterval(function () {
    rot.style.opacity = '0';
    setTimeout(function () {
     i = (i + 1) % msgs.length;
     rot.textContent = msgs[i];
     rot.style.opacity = '1';
    }, 300);
   }, 3500);
  });
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formula-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
 var root=document.querySelector('[data-ff]'); if(!root) return;
 var DATA={}; try{ DATA=JSON.parse(document.querySelector('[data-ff-data]').textContent);}catch(e){}
 /* Price test. A no-op unless a test is running and this visitor is in the
    lower-priced group, in which case the ids and figures above are swapped for
    that group's before anything below reads them. The helper is defined inline
    in the head by snippets/yc-price-test.liquid, which is the only code that
    runs before this script. */
 try{ if(window.YC_PT && window.YC_PT.patch) DATA=window.YC_PT.patch(DATA,'ff'); }catch(e){}
 /* Which product the quiz should finish on (passed as ?product=<handle> by the page the link came from). Defaults to the eye serum. */
 var TARGET=null; try{ TARGET=(new URLSearchParams(location.search)).get('product'); }catch(e){}
 if(!TARGET || !DATA.products || !DATA.products[TARGET]) TARGET='advanced-eye-serum-for-men';
 var TP=(DATA.products&&DATA.products[TARGET])||null;
 var SHADES=[
  {k:'porcelain',label:'Porcelain',c1:'#F6E3D6',c2:'#E7CDB8',formula:'M-'},
  {k:'light',label:'Light',c1:'#EFD3B9',c2:'#DFBD9A',formula:'M'},
  {k:'medium',label:'Medium',c1:'#DDB08A',c2:'#CA986D',formula:'M'},
  {k:'tan',label:'Tan',c1:'#C6905F',c2:'#AD784A',formula:'M'},
  {k:'deep-tan',label:'Deep Tan',c1:'#9C6C43',c2:'#7C5230',formula:'M'},
  {k:'deep',label:'Deep',c1:'#6B4A34',c2:'#472E1F',formula:'M+'}
 ];
 var FORMULAS={
  'M-':{name:'FORMULA M−',tones:'the fairest ~5% of skin tones',c1:'#F4E7D6',c2:'#F0E4D2',dot:'#F0E4D2'},
  'M':{name:'FORMULA M',tones:'~85% of skin tones',c1:'#D6B58E',c2:'#C9A57E',dot:'#C9A57E'},
  'M+':{name:'FORMULA M+',tones:'deeper skin tones (~10%)',c1:'#7C5334',c2:'#6B4A34',dot:'#6B4A34'}
 };
 var AGES=['Under 25','25–34','35–44','45–54','55+'];
 var CONCERNS=['Dark circles','Puffiness','Fine lines','Eye bags / sagging','Tired, dull look','Dryness'];
 var ROUTINES=['Nothing yet','Just cleanse','A few products','A full routine'];
 var st={step:'intro',age:null,concerns:[],routine:null,shade:null,email:'',purchase:'once',planId:null,upsell:false,added:false};
 var loadingT,addedT;
 var $=function(s,c){return (c||root).querySelector(s);};

 function fk(){ return st.shade==null?'M':SHADES[st.shade].formula; }
 function grad(a,b){ return 'linear-gradient(160deg,'+a+','+b+')'; }

 function buildStatic(){
  // ages
  var ag=$('[data-ff-ages]'); ag.innerHTML='';
  AGES.forEach(function(a){var b=document.createElement('button');b.type='button';b.className='ff__opt';b.textContent=a;b.addEventListener('click',function(){st.age=a;render();setTimeout(function(){go('concerns');},140);});ag.appendChild(b);});
  // concerns
  var co=$('[data-ff-concerns]'); co.innerHTML='';
  CONCERNS.forEach(function(c){var b=document.createElement('button');b.type='button';b.className='ff__opt ff__opt--multi';b.textContent=c;b.addEventListener('click',function(){var i=st.concerns.indexOf(c);if(i>-1)st.concerns.splice(i,1);else st.concerns.push(c);render();});co.appendChild(b);});
  // routines
  var ro=$('[data-ff-routines]'); ro.innerHTML='';
  ROUTINES.forEach(function(r){var b=document.createElement('button');b.type='button';b.className='ff__row';b.innerHTML='<span class="ff__rowdot"></span><span class="ff__rowlabel"></span>';b.querySelector('.ff__rowlabel').textContent=r;b.addEventListener('click',function(){st.routine=r;render();setTimeout(function(){go('tone');},140);});ro.appendChild(b);});
  // swatches
  var sw=$('[data-ff-swatches]'); sw.innerHTML='';
  SHADES.forEach(function(s,i){var b=document.createElement('button');b.type='button';b.className='ff__swatch';b.innerHTML='<span class="ff__swtile" style="background:'+grad(s.c1,s.c2)+'"></span><span class="ff__swlabel"></span>';b.querySelector('.ff__swlabel').textContent=s.label;b.addEventListener('click',function(){st.shade=i;render();});sw.appendChild(b);});
  // legend
  var lg=$('[data-ff-legend]'); lg.innerHTML='';
  ['M-','M','M+'].forEach(function(k){var F=FORMULAS[k];var d=document.createElement('div');d.className='ff__leg';d.dataset.ffLegkey=k;d.innerHTML='<span class="ff__legdot" style="background:'+F.dot+'"></span><span class="ff__legname">'+F.name+'</span><span class="ff__legtones">'+F.tones+'</span>';lg.appendChild(d);});
  // once/sub prices
  if(DATA.once)$('[data-ff-onceprice]').textContent=DATA.once.priceLabel;
  if(DATA.sub){ $('[data-ff-subprice]').textContent=DATA.sub.priceLabel; $('[data-ff-subrow]').hidden=false; }
  if(DATA.eyeImage)$('[data-ff-eyeimg]').src=DATA.eyeImage;
  // upsell visibility + copy
  $('[data-ff-upsell]').hidden = !(DATA.showUpsell!==false);
  if(DATA.kit)$('[data-ff-upsub]').textContent='Make it The Starter Kit, '+DATA.kit.priceLabel;
  // email discount copy
  var disc=(DATA.discount&&DATA.discount!=='none')?DATA.discount:null;
  $('[data-ff-emailhead]').innerHTML = disc? ('Unlock your formula<br>+ '+disc+' off.') : 'Unlock your formula.';
  $('[data-ff-emailp]').textContent = "We'll send your personalised Melanin Adaptive Technology™ match to your inbox"+(disc? (', plus '+disc+' off your first order.'):'.');
  var skip=$('[data-ff-skip]'); skip.hidden = !!DATA.emailRequired;
  // Intro image reflects the product the finder ends on (Starter Kit / Core Trio / eye serum).
  var intro=$('[data-ff-introimg]'); if(intro && TP && TP.image){ intro.style.backgroundImage="url('"+TP.image+"')"; }
 }

 function render(){
  root.setAttribute('data-step',st.step);
  // progress
  var order=['age','concerns','routine','tone']; var idx=order.indexOf(st.step);
  for(var i=0;i<4;i++){ var c=$('[data-ff-pcell="'+i+'"]'); c.classList.toggle('is-on', i<=idx); }
  // ages
  Array.prototype.forEach.call($('[data-ff-ages]').children,function(b){b.classList.toggle('is-on',b.textContent===st.age);});
  // concerns
  Array.prototype.forEach.call($('[data-ff-concerns]').children,function(b){b.classList.toggle('is-on',st.concerns.indexOf(b.textContent)>-1);});
  var cbtn=$('[data-ff-next="concerns"]'); cbtn.disabled=st.concerns.length===0;
  // routines
  Array.prototype.forEach.call($('[data-ff-routines]').children,function(b){b.classList.toggle('is-on',b.querySelector('.ff__rowlabel').textContent===st.routine);});
  // swatches
  Array.prototype.forEach.call($('[data-ff-swatches]').children,function(b,i){b.classList.toggle('is-on',st.shade===i);});
  var tOK=st.shade!=null; $('[data-ff-next="tone"]').disabled=!tOK;
  $('[data-ff-tonehint]').textContent = tOK? ('Matched to '+FORMULAS[fk()].name.replace('FORMULA ','Formula ')) : '';
  // email dot
  var Fk=FORMULAS[fk()]; $('[data-ff-emaildot]').style.background=grad(Fk.c1,Fk.c2);
  var emOK=/.+@.+\..+/.test(st.email); $('[data-ff-revealemail]').disabled=!emOK;
  // result
  var F=FORMULAS[fk()];
  var tv=(TP&&TP.variants&&TP.variants['Formula '+fk()])||null;
  var tprice=(tv&&tv.priceLabel)||(TP&&TP.base&&TP.base.priceLabel)||(DATA.once?DATA.once.priceLabel:'');
  var isKit=!!(TP&&TP.isKit);
  var shadeLabel = st.shade!=null? SHADES[st.shade].label.toLowerCase() : 'your';
  var concernPhrase = st.concerns.length? st.concerns.slice(0,2).map(function(c){return c.toLowerCase();}).join(' and ') : 'a tired, dull look';
  var pt=$('[data-ff-ptitle]'); if(pt&&TP) pt.textContent=TP.title;
  $('[data-ff-rationale]').textContent='Based on your '+shadeLabel+' skin tone and your focus on '+concernPhrase+', we matched you to '+F.name.replace('FORMULA','Formula')+(isKit? (', so your '+TP.title+' comes with the eye serum tuned to how your skin holds pigment and light.') : (', the '+(TP?TP.title:'Advanced Eye Serum')+' tuned to how your skin holds pigment and light.'));
  $('[data-ff-chipdot]').style.background=grad(F.c1,F.c2);
  $('[data-ff-chipname]').textContent=F.name;
  var shadeTube=(DATA.formulaImages&&DATA.formulaImages[fk()])||DATA.eyeImage;
  // Kits show their own PDP product image (both/all products); the eye serum shows the matched shade tube.
  var eyeSrc = isKit ? ((TP&&TP.image)||DATA.coreTrioImage||shadeTube) : ((tv&&tv.img)||shadeTube);
  var ei=$('[data-ff-eyeimg]'); if(ei&&eyeSrc) ei.src=eyeSrc;
  var ki=$('[data-ff-kitimg]'); if(ki) ki.hidden=true;
  var ci=$('[data-ff-cardimg]'); if(ci) ci.classList.remove('ff__cardimg--kit');
  $('[data-ff-pdesc]').textContent = isKit ? ('Your two-step kit in '+F.name.replace('FORMULA ','Formula ')+'. The Advanced Eye Serum calibrated for '+F.tones+', plus the Mattifying Moisturiser.') : ('Calibrated for '+F.tones+'. Light-reflecting mineral complex, marine bioactives and wild ginger, tuned to your under-eye biology.');
  // target prices. The subscribe price must follow the CHOSEN plan (1/2/3-month carry
  // different discounts), otherwise we show a price the customer is not charged.
  var planPrice=(TP&&TP.planPrices&&st.planId)?TP.planPrices[String(st.planId)]:null;
  var subPrice=planPrice||(TP&&TP.sub?TP.sub.priceLabel:'');
  $('[data-ff-onceprice]').textContent=tprice;
  if(TP&&TP.sub){ $('[data-ff-subprice]').textContent=subPrice; $('[data-ff-subrow]').hidden=false; }
  else if(TP){ $('[data-ff-subrow]').hidden=true; if(st.purchase==='sub') st.purchase='once'; }
  // buy rows
  $('[data-ff-buy="once"]').classList.toggle('is-on',st.purchase==='once');
  var subrow=$('[data-ff-buy="sub"]'); if(subrow) subrow.classList.toggle('is-on',st.purchase==='sub');
  // delivery frequency, straight from the product's Recharge selling plans
  var plans=(TP&&TP.plans)||[];
  var freqWrap=$('[data-ff-freq]'), freqSel=$('[data-ff-freqsel]');
  if(freqSel && freqSel.getAttribute('data-for')!==TARGET){
   freqSel.innerHTML='';
   plans.forEach(function(pl){ var o=document.createElement('option'); o.value=pl.id; o.textContent=pl.name; freqSel.appendChild(o); });
   freqSel.setAttribute('data-for',TARGET);
   st.planId=plans.length?plans[0].id:null;
  }
  if(freqSel && st.planId) freqSel.value=String(st.planId);
  if(freqWrap) freqWrap.hidden=!(st.purchase==='sub' && plans.length>0);
  // legend opacity
  Array.prototype.forEach.call($('[data-ff-legend]').children,function(d){d.style.opacity = d.dataset.ffLegkey===fk()?'1':'0.4';});
  // upsell (only when the match is the eye serum itself)
  $('[data-ff-upsell]').hidden = isKit || (DATA.showUpsell===false);
  var upt=$('[data-ff-uptoggle]'); upt.classList.toggle('is-on',st.upsell); upt.textContent=st.upsell?'✓ ADDED':'ADD';
  // add-to-cart label
  var add=$('[data-ff-add]');
  if(st.added){ add.textContent='✓ ADDED TO CART'; }
  else if(st.upsell && !isKit){ add.textContent='ADD STARTER KIT'+(DATA.kit?(', '+DATA.kit.priceLabel):''); }
  else { var pl=(st.purchase==='sub'&&TP&&TP.sub)?subPrice:tprice; add.textContent=(isKit?'ADD THE KIT':'ADD TO CART')+(pl?(', '+pl):''); }
 }

 function go(step){ st.step=step; if(step==='loading'){ clearTimeout(loadingT); loadingT=setTimeout(function(){go('result');render();},2200);} render(); window.scrollTo({top:0,behavior:'smooth'}); }

 function captureEmail(email){
  try{
   if(window.klaviyo && email){
    if(typeof window.klaviyo.identify==='function'){ window.klaviyo.identify({'$email':email}); }
    else if(window.klaviyo.push){ window.klaviyo.push(['identify',{'$email':email}]); }
    var props={ formula: FORMULAS[fk()].name, shade: st.shade!=null?SHADES[st.shade].label:null, concerns: st.concerns.join(', ') };
    if(window.klaviyo.push){ window.klaviyo.push(['track','Completed Formula Finder',props]); }
   }
  }catch(e){}
 }

 function addToCart(){
  var items=[];
  var isKit=!!(TP&&TP.isKit);
  if(st.upsell && !isKit && DATA.kit){ var kt={id:DATA.kit.variantId,quantity:1}; if(st.purchase==='sub'&&DATA.kit.sellingPlanId){ kt.selling_plan=DATA.kit.sellingPlanId; } items.push(kt); }
  else { var tv=(TP&&TP.variants&&TP.variants['Formula '+fk()])||null; var vid=(tv&&tv.id)||(DATA.once&&DATA.once.variantId); if(!vid) return; var it={id:vid,quantity:1}; if(st.purchase==='sub'&&TP&&TP.sub){ it.selling_plan = st.planId || TP.sub.sellingPlanId; } items.push(it); }
  if(!items.length) return;
  st.added=true; render(); clearTimeout(addedT); addedT=setTimeout(function(){st.added=false;render();},2600);
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
   .then(function(r){return r.json();})
   .then(function(){
    document.dispatchEvent(new CustomEvent('yc:cart:updated'));
    var tog=document.querySelector('[data-yc-cart-toggle]'); if(tog){ tog.click(); }
   }).catch(function(){});
 }

 root.addEventListener('click',function(e){
  var t=e.target.closest('[data-ff-begin],[data-ff-back],[data-ff-next],[data-ff-revealemail],[data-ff-skip],[data-ff-buy],[data-ff-uptoggle],[data-ff-add],[data-ff-retake]');
  if(!t) return;
  if(t.hasAttribute('data-ff-begin')){ go('age'); }
  else if(t.hasAttribute('data-ff-back')){ var b={concerns:'age',routine:'concerns',tone:'routine',email:'tone'}; go(b[st.step]||'intro'); }
  else if(t.hasAttribute('data-ff-next')){ var n=t.getAttribute('data-ff-next'); if(n==='concerns'&&st.concerns.length){go('routine');} else if(n==='tone'&&st.shade!=null){go('email');} }
  else if(t.hasAttribute('data-ff-revealemail')){ if(/.+@.+\..+/.test(st.email)){ captureEmail(st.email); go('loading'); } }
  else if(t.hasAttribute('data-ff-skip')){ if(!DATA.emailRequired){ go('loading'); } }
  else if(t.hasAttribute('data-ff-buy')){ st.purchase=t.getAttribute('data-ff-buy'); render(); }
  else if(t.hasAttribute('data-ff-uptoggle')){ st.upsell=!st.upsell; st.added=false; render(); }
  else if(t.hasAttribute('data-ff-add')){ addToCart(); }
  else if(t.hasAttribute('data-ff-retake')){ st={step:'intro',age:null,concerns:[],routine:null,shade:null,email:'',purchase:'once',planId:null,upsell:false,added:false}; render(); window.scrollTo({top:0}); }
 });
 var freqSelEl=$('[data-ff-freqsel]'); if(freqSelEl){ freqSelEl.addEventListener('change',function(){ st.planId=freqSelEl.value; render(); }); }
 var emailInput=$('[data-ff-email]'); if(emailInput){ emailInput.addEventListener('input',function(){st.email=emailInput.value;render();}); emailInput.addEventListener('keydown',function(e){ if(e.key==='Enter'&&/.+@.+\..+/.test(st.email)){ captureEmail(st.email); go('loading'); } }); }

 buildStatic(); render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-eye-targets"] && !Shopify.designMode) return;
  try {
    
 (function(){
  function init(root){
   (root||document).querySelectorAll('[data-yc-doses]').forEach(function(sc){
    if(sc.dataset.doseInit) return; sc.dataset.doseInit='1';
    var dots = sc.parentElement.querySelector('[data-yc-dosedots]');
    var spans = dots ? dots.querySelectorAll('span') : [];
    sc.addEventListener('scroll', function(){
     var i = Math.round(sc.scrollLeft / sc.clientWidth);
     for(var k=0;k<spans.length;k++){ spans[k].classList.toggle('is-active', k===i); }
    }, {passive:true});
   });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init(document);});}else{init(document);}
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
 /* If the viewport crosses the 640px breakpoint after load, the newly visible hero video
    may never have selected a source (its <source media> did not match at parse time).
    Give it its source directly and start playback. */
 function ycHeroEnsure(){
  document.querySelectorAll('video.yc-hero__vid').forEach(function(v){
   if (!v.offsetParent) return; /* hidden at this breakpoint */
   if (v.currentSrc || v.getAttribute('src')) { if (v.paused && v.hasAttribute('data-yc-autoplay')) v.play().catch(function(){}); return; }
   var s = v.querySelector('source');
   if (s && s.getAttribute('src')) { v.src = s.getAttribute('src'); v.load(); v.play().catch(function(){}); return; }
   /* preload="none" with a matching <source>: nudge it to load, then play */
   v.load(); v.play().catch(function(){});
  });
 }
 var mq = window.matchMedia('(max-width: 640px)');
 if (mq.addEventListener) mq.addEventListener('change', ycHeroEnsure);
 else if (mq.addListener) mq.addListener(ycHeroEnsure);
 /* DEFERRED ON PURPOSE. The hero video is ~3.7MB and is NOT the LCP element: measured
    22.09.26, LCP is the H1 on desktop and the sub-line on mobile, both text. It was still
    competing for bandwidth during first paint on slow connections, so autoplay was removed
    in favour of preload="none" plus this hook, which starts it after the load event.
    The swap is invisible because each poster is frame 0 of its own video.
    If JS never runs, the poster simply remains: a real still, not a blank box. */
 if (document.readyState === 'complete') ycHeroEnsure();
 else window.addEventListener('load', ycHeroEnsure);
 /* NO DOMContentLoaded hook here. It used to kick the video at DOMContentLoaded, which is
    before load completes and would defeat the deferral entirely. The matchMedia listener
    above already covers a breakpoint cross, and window load covers the initial start. */
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-main-product"] && !Shopify.designMode) return;
  try {
    
 (function () {
  function initMP(root) {
   var mp = (root || document).querySelector('[data-yc-mp]');
   if (!mp || mp.dataset.ycMpInit === '1') return;
   mp.dataset.ycMpInit = '1';

   var form = mp.querySelector('#yc-product-form') || mp.querySelector('form');
   var idField = mp.querySelector('[data-yc-variant-id]');
   var priceEl = mp.querySelector('[data-yc-price]');
   var subWas = mp.querySelector('[data-yc-sub-was]');
   var subNow = mp.querySelector('[data-yc-sub-now]');
   var cta = mp.querySelector('[data-yc-add]');
   var ctaFormula = mp.querySelector('[data-yc-formula-label]');

   /* ---- Mobile sticky buy bar: reveal once the real CTA scrolls out of view ---- */
   (function stickyATC(){
    var bar = document.querySelector('[data-yc-stickyatc]');
    if (!bar || !cta) return;
    /* No width test here on purpose. CSS owns the breakpoint (.yc-stickyatc is
       display:none above 759px), so JS only tracks scroll state. Testing width
       in JS ran once at load, which meant a page that loaded wide and was then
       resized or rotated never initialised the bar at all. */
    bar.hidden = false;
    bar.setAttribute('aria-hidden','false');
    /* The bar replaces the header rather than stacking under it. visibility,
       not display, so the header keeps its layout box and nothing below it
       jumps as it goes. */
    var hdr = document.querySelector('[data-yc-header]');
    var ann = document.querySelector('.yc-annbar');
    var deskBar = bar.classList.contains('yc-stickyatc--desk');
    var show = function(on){ bar.classList.toggle('is-visible', !!on); };

    /* The header is driven off the bar's ACTUAL state on every frame, not off the
       observer's transitions. An earlier version hid the header inside the
       observer callback, which meant any missed callback (a background tab, a
       fast scroll, a coalesced entry) left the header hidden with nothing to
       restore it. Reading the state each frame cannot get stuck. */
    /* Each packshot carries its own baked-in background and they are not identical
       between products: the eye serum sits on #F3EFEC where the bar was #F2F1EF,
       which is close enough to read as a mistake and far enough to draw a visible
       tile edge around the thumbnail. Sampling a corner pixel of the actual image
       and painting the bar with it means every PDP matches its own product shot
       with nothing to configure. Same-origin, so the canvas is readable; wrapped
       because a tainted or failed image must fall back to the CSS default rather
       than throw. */
    (function paintBarFromPackshot(){
     /* Prefer the full-size hero shot as the sample source: it is the same
        packshot, at higher resolution, so the colour read is steadier. */
     var img = document.querySelector('.yc-mp__hero-img');
     if (!img) {
      /* On mobile the standalone hero is display:none and the carousel's lead
         slide stands in for it, so sample that instead. Skip the award badges,
         which live inside the same card and have transparent corners. */
      var cand = document.querySelectorAll('.yc-mp__card--herolead img');
      for (var ci = 0; ci < cand.length; ci++) {
       if (!cand[ci].closest('.yc-mp__badges')) { img = cand[ci]; break; }
      }
     }
     if (!img) img = bar.querySelector('.yc-stickyatc__thumb img');
     if (!img) return;
     function sample(){
      try {
       if (!img.naturalWidth) return;
       var c = document.createElement('canvas');
       c.width = img.naturalWidth; c.height = img.naturalHeight;
       var ctx = c.getContext('2d');
       ctx.drawImage(img, 0, 0);
       var d = ctx.getImageData(2, 2, 1, 1).data;
       if (d[3] < 250) return;                 /* transparent corner, nothing to match */
       var bed = 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
       bar.style.setProperty('--yc-bar-bg', bed);
       /* The hero's bed was a flat #F2F1EF while the packshot itself sits on its
          own slightly different white, which drew a visible rectangle inside the
          container. Painting the container with the image's own corner colour
          removes the seam on every product without hard-coding a value. */
       var heroBed = document.querySelector('.yc-mp__hero');
       if (heroBed) heroBed.style.background = bed;
       /* The mobile carousel's lead slide is a second bed showing the same
          packshot, and it was still painting the flat bone. Measured 7 September:
          the bed was #F2F1EF against a packshot sitting on #F0EEED on four of the
          six products, which is exactly the seam this function exists to remove.
          The other two are transparent cutouts, and the alpha guard above already
          leaves those on the CSS default, which is correct: there is no baked
          background to match. */
       var leads = document.querySelectorAll('.yc-mp__card--herolead');
       for (var li = 0; li < leads.length; li++) leads[li].style.background = bed;
      } catch (e) { /* keep the CSS default */ }
     }
     if (img.complete) sample(); else img.addEventListener('load', sample);
    })();

    var hdrHidden = null;
    function syncHeader(){
     var want = bar.classList.contains('is-visible')
             && deskBar
             && window.matchMedia('(min-width:760px)').matches;
     if (want === hdrHidden) return;          /* only touch the DOM on a change */
     hdrHidden = want;
     if (hdr) hdr.style.visibility = want ? 'hidden' : '';
     if (ann) ann.style.visibility = want ? 'hidden' : '';
    }
    var hTick = false;
    function onHdrScroll(){
     if (hTick) return;
     hTick = true;
     requestAnimationFrame(function(){ hTick = false; syncHeader(); });
    }
    window.addEventListener('scroll', onHdrScroll, { passive: true });
    window.addEventListener('resize', onHdrScroll, { passive: true });
    /* Restore on the way out, so a back-navigation never lands on a hidden header. */
    window.addEventListener('pagehide', function(){
     if (hdr) hdr.style.visibility = '';
     if (ann) ann.style.visibility = '';
    });
    syncHeader();
    if ('IntersectionObserver' in window) {
     new IntersectionObserver(function(entries){
      entries.forEach(function(e){ show(!e.isIntersecting && e.boundingClientRect.top < 0); });
     }, { threshold: 0 }).observe(cta);
    } else {
     window.addEventListener('scroll', function(){
      show(cta.getBoundingClientRect().bottom < 0);
     }, { passive: true });
    }
    /* Mirror the buy box into the bar so the bar can never disagree with it:
       price, chosen formula, and whether subscribe is selected. Without this a
       man who picked M+ or switched to subscribe sees the wrong thing in the
       bar he actually taps. */
    var sp = bar.querySelector('[data-yc-sticky-price]');
    var spCta = bar.querySelector('[data-yc-sticky-cta-price]');
    if ((sp || spCta) && priceEl) {
     var mirrorPrice = function(){
      if (sp) sp.textContent = priceEl.textContent;
      if (spCta) spCta.textContent = priceEl.textContent;
     };
     new MutationObserver(mirrorPrice)
      .observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    var sf = bar.querySelector('[data-yc-sticky-formula]');
    if (sf && ctaFormula) {
     new MutationObserver(function(){ sf.textContent = ctaFormula.textContent; })
      .observe(ctaFormula, { childList: true, characterData: true, subtree: true });
    }
    var splan = bar.querySelector('[data-yc-sticky-plan]');
    if (splan) {
     var syncPlan = function(){
      var f = document.querySelector('[data-yc-selling-plan]');
      splan.hidden = !(f && f.value);
     };
     syncPlan();
     bar.closest('body').addEventListener('change', syncPlan, true);
     bar.closest('body').addEventListener('click', function(){ setTimeout(syncPlan, 60); }, true);
    }

    /* ---- Desktop controls ----
       These forward to the real controls and read their state back. They hold
       no state of their own, so there is nothing that can drift out of sync
       with what the form will actually submit. */
    /* Availability. The real CTA is disabled and relabelled when the chosen
       variant is out of stock (see the variant-change handler). Without this
       the bar would still read ADD TO BAG on a sold-out formula and take the
       click, only for the cart to reject it. */
    var barCta = bar.querySelector('[data-yc-sticky-add]');
    if (barCta) {
     /* Write to the label span, never to the button. Setting textContent on the
        button itself replaced its children, which silently deleted the price and
        the separator the moment this ran, and it runs on load. */
     var barCtaLabel = barCta.querySelector('[data-yc-sticky-cta-label]');
     var syncAvail = function(){
      barCta.disabled = cta.disabled;
      var txt = cta.disabled ? 'SOLD OUT' : 'ADD TO BAG';
      if (barCtaLabel) barCtaLabel.textContent = txt; else barCta.textContent = txt;
     };
     new MutationObserver(syncAvail).observe(cta, { attributes:true, attributeFilter:['disabled'] });
     syncAvail();
    }

    var barPills = bar.querySelectorAll('[data-yc-sticky-formula-btn]');
    if (barPills.length) {
     var realPill = function(v){
      return mp.querySelector('[data-yc-formula="' + (v || '').replace(/"/g, '\\"') + '"]');
     };
     var syncPills = function(){
      [].forEach.call(barPills, function(b){
       var t = realPill(b.getAttribute('data-yc-sticky-formula-btn'));
       var on = !!(t && t.getAttribute('data-selected') === 'true');
       b.setAttribute('data-selected', on ? 'true' : 'false');
       b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      /* Keep the description on the chosen formula, unless a hover is currently
         previewing a different one. */
      if (descEl && !descEl.classList.contains('is-preview')) restDesc();
     };
     /* Description line: shows the hovered formula, and settles back on the
        chosen one when the cursor leaves. Focus is wired up too so it is not
        mouse-only. */
     var descEl = bar.querySelector('[data-yc-sticky-desc]');
     var descFor = function(b){ return b ? (b.getAttribute('data-yc-sticky-desc-text') || '') : ''; };
     var restDesc = function(){
      if (!descEl) return;
      descEl.classList.remove('is-preview');
      descEl.textContent = descFor(bar.querySelector('[data-yc-sticky-formula-btn][data-selected="true"]'));
     };
     var previewDesc = function(b){
      if (!descEl) return;
      var t = descFor(b);
      if (!t) return;
      descEl.classList.add('is-preview');
      descEl.textContent = t;
     };

     [].forEach.call(barPills, function(b){
      b.addEventListener('click', function(){
       var t = realPill(b.getAttribute('data-yc-sticky-formula-btn'));
       if (t) t.click();
      });
      b.addEventListener('mouseenter', function(){ previewDesc(b); });
      b.addEventListener('focus', function(){ previewDesc(b); });
      b.addEventListener('mouseleave', restDesc);
      b.addEventListener('blur', restDesc);
     });
     [].forEach.call(mp.querySelectorAll('[data-yc-formula]'), function(p){
      new MutationObserver(syncPills).observe(p, { attributes:true, attributeFilter:['data-selected'] });
     });
     syncPills();
    }

    var barPlans = bar.querySelectorAll('[data-yc-sticky-plan-btn]');
    if (barPlans.length) {
     var realRow = function(v){
      var i = mp.querySelector('.yc-mp__prow input[value="' + v + '"]');
      return i ? i.closest('.yc-mp__prow') : null;
     };
     var syncPlans = function(){
      [].forEach.call(barPlans, function(b){
       var r = realRow(b.getAttribute('data-yc-sticky-plan-btn'));
       var on = !!(r && r.getAttribute('data-selected') === 'true');
       b.setAttribute('data-selected', on ? 'true' : 'false');
       b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      /* Prices in the bar track the buy box: the one-time figure changes with
         the formula, and the subscribe figure changes with formula and cadence. */
      var ot = bar.querySelector('[data-yc-sticky-onetime]');
      if (ot && priceEl) ot.textContent = priceEl.textContent;
      var sn = bar.querySelector('[data-yc-sticky-subnow]');
      if (sn && subNow) sn.textContent = subNow.textContent;
      /* The struck-through figure is the one-time price of the same variant,
         which is what the saving is measured against. */
      var sw = bar.querySelector('[data-yc-sticky-subwas]');
      if (sw && priceEl) sw.textContent = priceEl.textContent;
     };
     [].forEach.call(barPlans, function(b){
      b.addEventListener('click', function(){
       var r = realRow(b.getAttribute('data-yc-sticky-plan-btn'));
       if (r) r.click();
      });
     });
     [].forEach.call(mp.querySelectorAll('.yc-mp__prow'), function(r){
      new MutationObserver(syncPlans).observe(r, { attributes:true, attributeFilter:['data-selected'] });
     });
     /* The frequency dropdown rewrites the subscribe price without touching any
        data-selected attribute, so watch the price nodes directly too. */
     [priceEl, subNow].forEach(function(n){
      if (n) new MutationObserver(syncPlans).observe(n, { childList:true, characterData:true, subtree:true });
     });
     syncPlans();
    }
   })();
   var fIndex = mp.dataset.formulaIndex;
   fIndex = (fIndex === '' || fIndex === 'null') ? null : parseInt(fIndex, 10);

   var variants = [];
   try { variants = JSON.parse(mp.querySelector('[data-yc-variants]').textContent); } catch (e) {}
   // Pre-rendered, market-converted money strings keyed by variant id (see [data-yc-prices]).
   var priceMap = {};
   try { priceMap = JSON.parse(mp.querySelector('[data-yc-prices]').textContent); } catch (e) {}

   // current selection state
   var pills = mp.querySelectorAll('[data-yc-formula]');

   function currentFormula() {
    var sel = mp.querySelector('[data-yc-formula][data-selected="true"]');
    return sel ? sel.getAttribute('data-yc-formula') : null;
   }

   function matchVariant() {
    if (fIndex == null) return variants[0];
    var f = currentFormula();
    for (var i = 0; i < variants.length; i++) {
     var opts = [variants[i].option1, variants[i].option2, variants[i].option3];
     if (opts[fIndex] === f) return variants[i];
    }
    return variants[0];
   }

   function render() {
    var v = matchVariant();
    if (!v) return;
    if (idField) idField.value = v.id;
    var pm = priceMap[v.id] || priceMap[String(v.id)] || {};
    if (priceEl && pm.price) priceEl.textContent = pm.price;
    if (subWas && pm.price) subWas.textContent = pm.price;
    if (subNow && pm.sub) subNow.textContent = pm.sub;
    if (ctaFormula && fIndex != null) ctaFormula.textContent = String(v['option' + (fIndex + 1)]).toUpperCase();
    if (cta) {
     cta.disabled = !v.available;
     var lbl = cta.querySelector('[data-yc-cta-label]');
     if (lbl && !v.available) lbl.textContent = 'SOLD OUT';
    }
   }

   pills.forEach(function (p) {
    p.addEventListener('click', function () {
     pills.forEach(function (x) { x.setAttribute('data-selected', 'false'); });
     p.setAttribute('data-selected', 'true');
     render();
    });
   });

   // one-time vs subscribe (+ delivery-frequency dropdown)
   var prows = mp.querySelectorAll('.yc-mp__prow');
   var planField = mp.querySelector('[data-yc-selling-plan]');
   var subFreq = mp.querySelector('[data-yc-subfreq]');
   var planSelect = mp.querySelector('[data-yc-plan-select]');
   function syncSubPrice() {
    if (!planSelect || !subNow) return;
    var opt = planSelect.options[planSelect.selectedIndex];
    var p = opt && opt.getAttribute('data-price');
    if (p) subNow.textContent = p;
   }
   function selectPurchase(row) {
    prows.forEach(function (r) { r.setAttribute('data-selected', 'false'); });
    row.setAttribute('data-selected', 'true');
    var input = row.querySelector('input');
    if (input) input.checked = true;
    var isSub = input && input.value === 'subscribe';
    if (subFreq) subFreq.hidden = !isSub;
    if (planField) {
     var val = isSub && planSelect ? planSelect.value : '';
     planField.value = val;
     planField.disabled = !val;
    }
    if (isSub) syncSubPrice();
   }
   prows.forEach(function (row) { row.addEventListener('click', function () { selectPurchase(row); }); });
   // Default to the pre-selected row (one-time purchase) so the price and
   // selling_plan state are wired up correctly on load.
   var ycDefaultRow = mp.querySelector('.yc-mp__prow[data-selected="true"]') || prows[0];
   if (ycDefaultRow) selectPurchase(ycDefaultRow);
   if (planSelect) planSelect.addEventListener('change', function () {
    if (planField) { planField.value = planSelect.value; planField.disabled = !planSelect.value; }
    syncSubPrice();
   });

   // AJAX add-to-bag: adds via the cart API instead of a form POST, so the
   // shopper stays on-page, the slide-out drawer opens (matching the quick-add
   // cards), and Shopify's cart-API fires the GA4 add_to_cart event (a plain
   // form POST to /cart does not, so the PDP button was previously untracked).
   if (form && cta) {
    form.addEventListener('submit', function (e) {
     e.preventDefault();
     if (cta.disabled || cta.dataset.ycLoading === '1') return;
     var vid = idField && idField.value;
     if (!vid) return;
     var item = { id: vid, quantity: 1 };
     if (planField && !planField.disabled && planField.value) item.selling_plan = planField.value;
     cta.dataset.ycLoading = '1';
     cta.classList.add('is-loading');
     fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
     })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
       var tog = document.querySelector('[data-yc-cart-toggle]');
       if (tog) { tog.click(); } else { window.location.href = '/cart'; }
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { cta.dataset.ycLoading = '0'; cta.classList.remove('is-loading'); });
    });
   }

   // gallery strip: progress fill + arrows
   var track = mp.querySelector('[data-yc-gallery-track]');
   var fill = mp.querySelector('[data-yc-strip-fill]');
   if (track && fill) {
    var updateFill = function () {
     var w = Math.max(track.clientWidth / track.scrollWidth, 0.1) * 100;
     var l = (track.scrollLeft / track.scrollWidth) * 100;
     fill.style.width = w + '%';
     fill.style.left = l + '%';
    };
    track.addEventListener('scroll', updateFill, { passive: true });
    window.addEventListener('resize', updateFill);
    updateFill();
    var card = track.querySelector('.yc-mp__card');
    var step = card ? card.offsetWidth + 16 : 440;
    var prev = mp.querySelector('[data-yc-strip-prev]');
    var next = mp.querySelector('[data-yc-strip-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step, behavior: 'smooth' }); });
   }

   render();
  }

  if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', function () { initMP(document); });
  } else { initMP(document); }
  document.addEventListener('shopify:section:load', function (e) { initMP(e.target); });
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-press-marquee"] && !Shopify.designMode) return;
  try {
    
(function(){
 function setMarqWidth(){
  document.querySelectorAll('.yc-press .yc-marquee').forEach(function(m){
   var items = m.querySelectorAll('.yc-marquee__item');
   var n = Math.floor(items.length / 2);
   if (n >= 1 && items[n]) {
    var w = items[n].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    if (w > 0) m.style.setProperty('--yc-marq-w', w + 'px');
   }
  });
 }
 setMarqWidth();
 window.addEventListener('load', setMarqWidth);
 window.addEventListener('resize', setMarqWidth);
})();

  } catch(e) { console.error(e); }
})();
})();
